import "core-js/modules/es.number.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import _objectSpread from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component, Prop, Emit, Provide, Watch } from 'vue-property-decorator';
import MeetingBook from '@/modules/SchdulePlan/meetingBook.vue';
import EmptyContent from '@/views/Layout/EmptyContent.vue';
import { addZero } from '@/utils/index';

var SchdulePlan = /*#__PURE__*/function (_Vue) {
  _inherits(SchdulePlan, _Vue);

  var _super = _createSuper(SchdulePlan);

  function SchdulePlan() {
    var _this;

    _classCallCheck(this, SchdulePlan);

    _this = _super.call(this);
    _this.startTime = '08:00';
    _this.endTime = '22:00';
    _this.interval = '30min';
    _this.timeList = [];
    _this.selectTribunalId = null;
    return _this;
  }

  _createClass(SchdulePlan, [{
    key: "allScheduleChange",
    value: function allScheduleChange(val) {}
  }, {
    key: "chooseTime",
    value: function chooseTime(params, tribunalId, tribunalName) {
      this.selectTribunalId = tribunalId;
      return _objectSpread(_objectSpread({}, params), {}, {
        tribunalId: tribunalId,
        tribunalName: tribunalName
      });
    }
  }, {
    key: "chooseStart",
    value: function chooseStart(tribunalId) {
      this.selectTribunalId = tribunalId;
    }
  }, {
    key: "getBackgroundBlock",
    value: function getBackgroundBlock() {
      for (var i = 0; i <= this.blockSum; i++) {
        this.timeList.push("".concat(addZero(Number(this.startTime.split(':')[0]) + i), ":00"));
      }
    }
  }, {
    key: "reset",
    value: function reset() {
      this.selectTribunalId = null;
    }
  }, {
    key: "created",
    value: function created() {
      this.getBackgroundBlock();
    }
  }, {
    key: "blockSum",
    get: function get() {
      return Number(this.endTime.split(':')[0]) - Number(this.startTime.split(':')[0]);
    }
  }]);

  return SchdulePlan;
}(Vue);

__decorate([Provide('selectTribunalId'), Prop()], SchdulePlan.prototype, "loading", void 0);

__decorate([Prop()], SchdulePlan.prototype, "allSchedule", void 0);

__decorate([Prop({
  default: false
})], SchdulePlan.prototype, "canEdit", void 0);

__decorate([Watch('allSchedule')], SchdulePlan.prototype, "allScheduleChange", null);

__decorate([Emit('chooseTime')], SchdulePlan.prototype, "chooseTime", null);

__decorate([Emit('chooseStart')], SchdulePlan.prototype, "chooseStart", null);

SchdulePlan = __decorate([Component({
  components: {
    MeetingBook: MeetingBook,
    EmptyContent: EmptyContent
  }
})], SchdulePlan);
export default SchdulePlan;